import { getSelectedBusinessId } from "selectors/businesses";
import { useMainApi } from "hooks";
import { useSelector } from "react-redux";
import MainApiRoutes from "const/MainApiRoutes";
import RestApi from "api/RestApi";

const useActivityInfo = ({ transactionId, fetchCondition = true, types = [], described = false }) => {
  const selectedBusinessId = useSelector(getSelectedBusinessId);

  const [{ result: rpaDetails }, rpaDetailsFetching] = useMainApi({
    method: RestApi.REQUEST_METHODS.POST,
    initialData: { result: null },
    fetchCondition,
    parameters: [
      `${MainApiRoutes.BUSINESSES}/${selectedBusinessId}${MainApiRoutes.ACTIVITY}${MainApiRoutes.RPA_DETAILS}/${transactionId}`,
      null,
      { described, types }
    ],
    dependencies: [transactionId, fetchCondition]
  });

  return { result: rpaDetails, fetching: rpaDetailsFetching };
};

export default useActivityInfo;
